import { App } from 'vue';
import { performanceService } from '@/services/performanceService';

export const performancePlugin = {
  install(app: App) {
    // Track component render performance
    app.config.performance = true;

    // Track route changes
    app.config.globalProperties.$trackRouteChange = () => {
      performanceService.trackCustomMetric('route_change', Date.now());
    };

    // Start long task monitoring
    performanceService.startLongTaskMonitoring();

    // Track initial page load
    if (typeof window !== 'undefined') {
      window.addEventListener('load', () => {
        performanceService.trackPageLoad();
      });
    }

    // Add performance mixin
    app.mixin({
      mounted() {
        const componentName = this.$options.name || 'Unknown';
        performanceService.trackCustomMetric(`component_mount_${componentName}`, Date.now());
      },

      beforeUnmount() {
        const componentName = this.$options.name || 'Unknown';
        performanceService.trackCustomMetric(`component_unmount_${componentName}`, Date.now());
      },
    });
  },
};
